import { render, staticRenderFns } from "./TheNotificationSnackbar.vue?vue&type=template&id=b04d9954"
import script from "./TheNotificationSnackbar.vue?vue&type=script&lang=js"
export * from "./TheNotificationSnackbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports